import { render } from "./Image.vue?vue&type=template&id=5e607950"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=5e607950&lang=css"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__